module.exports = __webpack_public_path__ + "static/media/pickup.7146acf5.svg";